import React, { useEffect, useState } from 'react';
import './App.css';
import Header from './components/page/Header';
import Body from './components/page/Body';
import Footer from './components/page/Footer';
import { getCookie, clearQueryParams, getExpireDate, updateUserLastAction, removeCurrentUserSession, deleteCookie, getAppUser} from './functions/utils'; // Import the utility function
import { TranslationProvider } from './components/utilities/TranslationContext';
function App() {
  useEffect(() =>{ 
    //Check query params to handle factview authentication
    const queryParams = new URLSearchParams(window.location.search);

    if(queryParams.get("auth_code") && queryParams.get("client_id")){
      fetch('https://api2.factview.nl/tokens/exchange_authcode?auth_code='+queryParams.get("auth_code")+"&client_id="+queryParams.get("client_id")+"&user_id="+queryParams.get("user_id"))
      .then(
        response => { return response.json()})
      .then(data => {
        const accessExpiration = getExpireDate(10);
        const refreshExpiration = getExpireDate(60 * 24 * 30);
        document.cookie = `factview_access=${data["accessToken"]};expires=`+accessExpiration+`;path=/`;
        document.cookie = `factview_refresh=${data["refreshToken"]};expires=`+refreshExpiration+`;path=/`;
        
        clearQueryParams(["auth_code", "client_id", "user_id"]);
      })
      .catch(error => {
        console.error('Error fetching token data:', error);
      });
    }
    else{
      createSession();
    }
  }, []); // [] makes sure that this useEffect block only runs on the first render of the component
  
  async function createSession(){
    try{
      const queryParams = new URLSearchParams(window.location.search);
      if(queryParams.get("logout")){
        clearQueryParams(["logout"]);
        await removeCurrentUserSession();
        await deleteCookie("factview_access");
        await deleteCookie("factview_refresh"); 
        await deleteCookie("session_id");
        var response = await fetch('/session/create');
        var responseData = await response.json();
        document.cookie = `session_id=${responseData["session_id"]}; path=/`
        
        var clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW;
        if(queryParams.get("import_ai")){
          clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW_AI;
        }
        window.location.href = `https://monitor.factview.nl/oauth/index.php?logout=1&client_id=${clientId}&import_session=${responseData["session_id"]}&fvai=${queryParams.get("fvai")}`;
      }

      if(queryParams.get("import_ai")){
        await deleteCookie("factview_access");
        await deleteCookie("factview_refresh"); 
        await deleteCookie("session_id");
      }
      var response = await fetch('/session/create');
      var responseData = await response.json();
      document.cookie = `session_id=${responseData["session_id"]}; path=/`;
      
      await factview_auth();
    }
    catch(error) {
      console.error('Error fetching session data:', error);
    }
    
  }
  async function factview_auth() {
    const queryParams = new URLSearchParams(window.location.search);
    updateUserLastAction();
    // Perform the factview authentication process
    var clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW;
    var appUser = await getAppUser();
    var fvai = "";

    if(queryParams.get("fvai")){
      fvai = "&fvai="+queryParams.get("fvai");
      clearQueryParams(["fvai"]);
    }
  
    if(appUser){
      clientId = appUser.client_id;
    }  
    if(queryParams.get("import_ai")){
      fvai = "&fvai="+queryParams.get("import_ai");
      clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW_AI;
    }
    try{
      fetch('https://api2.factview.nl/access_token', {
        headers: {
          Authorization: 'Bearer '+getCookie('factview_access'),
          // 'Content-Type': 'application/json',
        },
      }).then(response => {
        if (!response.ok) {
          if (response.status === 401 || response.status === 404) {
            // Handle token expiration or invalid token
            // Perform token refresh
            fetch('https://api2.factview.nl/refresh_token', {
              headers: {
                Authorization: 'Bearer '+getCookie('factview_refresh'),
              },
            })
            .then(response => {
              if (!response.ok) {
                if (response.status === 401|| response.status === 404) {
                  // Handle token expiration or invalid token
                  // Perform re-authentication

                  window.location.href = 'https://monitor.factview.nl/oauth/index.php?client_id='+clientId+'&import_session='+getCookie('session_id')+fvai;
                } else {
                  // Handle other authorization errors
                  // Display an error message to the user
                }
              } else {
                // Process the successful response
                return response.json();
              }
            }).then(responseData => {
                fetch('https://api2.factview.nl/tokens/refresh_access?refresh_token='+responseData["refresh_token"]).then(refreshResponse => {  
                  if(refreshResponse.ok){
                    return refreshResponse.json();
                  }
                }).then(refreshData => { 

                  updateSessionUserId(refreshData["user_id"]);

                  const accessExpiration = getExpireDate(10);
                  document.cookie = `factview_access=${refreshData["accessToken"]};expires=`+accessExpiration+`;path=/`;
                });
            })
            .catch(error => {
              // Handle network errors or other unexpected errors
            });
          } else {
            // Handle other authorization errors
            // Display an error message to the user
          }
        } 
        else {
          // Process the successful response
          return response.json();
        }
      }).then(responseData =>{
        updateSessionUserId(responseData["user_id"]);
      }).catch(error => {
        // Handle network errors or other unexpected errors
      });
    }
    catch{
      setTimeout(function(){
        return factview_auth();
      }, 500);
    }
  }

  function updateSessionUserId(user_id){
    if(getCookie('session_id')){
      fetch('/import_session/update_user_id', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          session_id: getCookie('session_id'),
          user_id: user_id,
        }),
      }).then(refreshResponse => {  
        if(refreshResponse.ok){
          return refreshResponse.json();
        }
      }).then(refreshData => {  

      return refreshData; 
      });
    }
    else{
    }
  }

  return (
    <div className="App">
      <TranslationProvider>
        {<Header />}
        {<Body />}
        {<Footer />}
      </TranslationProvider>
    </div>
  );
}

export default App;
